export function buildManifestPayload({episodeKey, uploadId, machineId, taskId, files}) {
    return {
        manifest_version: 1,
        upload_id: uploadId,
        episode_key: episodeKey,
        machine_id: machineId,
        task_id: taskId,
        created_at_utc: new Date().toISOString(),
        files: files
            .filter(({relative_path: path}) => path && !path.endsWith('.urdf')
                && (path === `${episodeKey}.mcap` || path.startsWith(`${episodeKey}/`)))
            .map(({relative_path, size_bytes, content_type}) => ({relative_path, size_bytes, content_type})),
    };
}

export async function uploadRawFile(item, signedUrl) {
    try {
        const response = await fetch(signedUrl, {
            method: 'PUT',
            body: item.file,
            headers: {'Content-Type': item.content_type || 'application/octet-stream'},
        });
        if (!response.ok) throw new Error(`Upload failed for ${item.relative_path}`);
        return true;
    } catch (error) {
        if (!item.relative_path.endsWith('.urdf')) throw error;
        console.warn(`Optional URDF upload failed: ${item.relative_path}; continuing.`, error);
        return false;
    }
}
